<template>
  <div class="cfo-report-history">
    <div class="history-header">
      <h3 class="history-title">经营简报历史</h3>
      <span class="history-count">共 {{ records.length }} 条记录</span>
    </div>
    <div class="history-list">
      <div
        v-for="(item, index) in records"
        :key="index"
        class="history-card"
      >
        <div class="card-top">
          <div class="card-title-h">{{ item.title }}</div>
          <div class="card-meta">
            <span class="card-category">{{ item.category }}</span>
            <span class="impact-tag" :class="`impact-tag--${item.impact}`">{{ item.impactLabel }}</span>
            <span class="card-date">{{ item.date }}</span>
          </div>
        </div>
        <div class="card-desc">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
const REPORT_HISTORY = [
  {
    title: '毛利率连续3月下滑至14.5%',
    category: '经营',
    impact: 'high',
    impactLabel: '高影响',
    date: '2026-06-24',
    desc: 'BOM物料成本上升(62%)和采购降本兑现不足(38%)为主要供应链拖累因素，6月预测优化空间668万。'
  },
  {
    title: '采购降本兑现率降至60%',
    category: '采购',
    impact: 'high',
    impactLabel: '高影响',
    date: '2026-06-23',
    desc: '当前兑现492万，缺口328万。直降谈判滞后与返利确认延迟为主因。'
  },
  {
    title: 'Q2现金流压力测试通过',
    category: '资金',
    impact: 'medium',
    impactLabel: '中影响',
    date: '2026-06-22',
    desc: 'Q4预计缺口1,860万，可用授信额度3.2亿可覆盖。建议提前与银行沟通。'
  },
  {
    title: 'C客户OEM业务毛利仅11%',
    category: '客户',
    impact: 'medium',
    impactLabel: '中影响',
    date: '2026-06-21',
    desc: '营收占比从5%升至18%，拉低综合毛利率1.05pct。'
  },
  {
    title: '质量返工率升至4.3%',
    category: '质量',
    impact: 'high',
    impactLabel: '高影响',
    date: '2026-06-20',
    desc: 'Q3返工率从2.1%升至4.3%，直接核算为毛利损失229万。'
  },
  {
    title: '6月收入目标达成率92%',
    category: '收入',
    impact: 'high',
    impactLabel: '高影响',
    date: '2026-06-19',
    desc: '华南区域3家大客户流失致订单下降6.2%，收入缺口约3,200万。'
  },
  {
    title: 'PCB/铜/锡物料涨价预警',
    category: '采购',
    impact: 'high',
    impactLabel: '高影响',
    date: '2026-06-18',
    desc: 'PCB(+8%)、铜(+5%)、锡(+4%)持续走高，Q3 BOM成本将进一步承压。'
  },
  {
    title: '制造费用重分类释放112万',
    category: '财务',
    impact: 'low',
    impactLabel: '低影响',
    date: '2026-06-17',
    desc: '通过费用重分类调整制造费率口径，月底前可完成。'
  },
  {
    title: 'CEO下达毛利率专项指令',
    category: '经营',
    impact: 'high',
    impactLabel: '高影响',
    date: '2026-06-15',
    desc: '要求明确毛利率下降原因并制定改善方案，CFO团队已启动E2E数据分析。'
  }
]

export default {
  name: 'CfoReportHistory',
  data() {
    return {
      records: REPORT_HISTORY
    }
  }
}
</script>

<style lang="scss" scoped>
.cfo-report-history {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px 20px;
  overflow: hidden;
  background: #fff;
}

.history-header {
  margin-bottom: 12px;
  flex-shrink: 0;
}

.history-title {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 4px;
}

.history-count {
  font-size: 11px;
  color: #94a3b8;
}

.history-list {
  flex: 1;
  overflow-y: auto;
  padding-right: 4px;
}

.history-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #e8ecf0;
  border-radius: 10px;
  background: #fff;
  margin-bottom: 6px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: rgba(74, 95, 243, 0.3);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.card-body {
  flex: 1;
  min-width: 0;
}

.card-title-h {
  font-size: 12px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.5;
  text-align: left;
  margin-bottom: 4px;
}

.card-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.card-category {
  font-size: 11px;
  color: #8898aa;
}

.impact-tag {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;

  &--high {
    background: #fef2f2;
    color: #e54b3d;
  }

  &--medium {
    background: #fff7ed;
    color: #d98213;
  }

  &--low {
    background: #f0fdf4;
    color: #0aa66a;
  }
}

.card-date {
  font-size: 11px;
  color: #94a3b8;
}

.card-desc {
  font-size: 11px;
  color: #64748b;
  line-height: 1.5;
  text-align: left;
}
</style>
